import Carousel from 'react-bootstrap/Carousel';
import { useEffect, useState } from 'react';
import { firestore } from '../../firebase/config';
import { collection, getDocs } from 'firebase/firestore';
import { Container } from 'react-bootstrap';

function QuoteCard() {
    const [quotes, setQuotes] = useState([]);

    const fetchQuotes = async () => {
        const req = collection(firestore, 'quotes');
        const second = await getDocs(req);
        const quoteList = second.docs.map(doc => doc.data());
        setQuotes(quoteList);
    }

    useEffect(() => {
    fetchQuotes();
    }, [])

    return (
        <div className="mainContainer">
            <Carousel>
                {quotes.map((quote, i)=>(
                    <Carousel.Item key={i} className="carousel-item">
                        <Container className='carousel-content'>
                            <div>
                                <h2>"{quote.quote}"</h2>
                                <p>{quote.person}</p>
                            </div>
                        </Container>
                    </Carousel.Item>
                ))}
            </Carousel>
        </div>
    );
}

export default QuoteCard;